import React from 'react';
import { Link } from 'react-router-dom';
import { useColorMode } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { FaHome, FaEnvelope, FaArrowRight } from 'react-icons/fa';

export default function NotFound() {
  const { colorMode } = useColorMode();
  const isDark = colorMode === 'dark';

  const links = [
    { to: '/', label: 'Accueil', icon: <FaHome /> },
    { to: '/blog', label: 'Blog' },
    { to: '/journal', label: 'Journal' },
    { to: '/contact', label: 'Contact', icon: <FaEnvelope /> },
  ];

  return (
    <div className={`min-h-screen flex flex-col items-center justify-center px-6 transition-colors duration-500 ${isDark ? 'bg-gray-900' : 'bg-[#F8FAFC]'}`}>

      {/* Gros 404 en arrière-plan */}
      <div className="relative flex flex-col items-center text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          className="select-none pointer-events-none"
          style={{
            fontSize: 'clamp(120px, 25vw, 280px)',
            fontWeight: 900,
            lineHeight: 1,
            color: isDark ? 'rgba(255,255,255,0.04)' : 'rgba(27,54,93,0.06)',
            letterSpacing: '-0.05em',
            userSelect: 'none',
          }}
        >
          404
        </motion.div>

        {/* Contenu superposé */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="absolute inset-0 flex flex-col items-center justify-center"
        >
          <div className="w-16 h-1 bg-yellow-400 rounded-full mb-6" />
          <h1 className={`text-3xl md:text-4xl font-black mb-3 ${isDark ? 'text-white' : 'text-[#1B365D]'}`}>
            Page introuvable
          </h1>
          <p className={`text-base md:text-lg max-w-md ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
            La page que vous cherchez n'existe pas ou a été déplacée.
          </p>
        </motion.div>
      </div>

      {/* Boutons de navigation */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.4 }}
        className="flex flex-wrap justify-center gap-3 mt-10"
      >
        {links.map(({ to, label, icon }) => (
          <Link
            key={to}
            to={to}
            className={`flex items-center gap-2 px-5 py-3 rounded-xl font-bold text-sm transition-all duration-200 ${
              to === '/'
                ? 'bg-[#1B365D] text-white hover:bg-[#1B365D]/80'
                : isDark
                ? 'bg-gray-800 text-gray-200 hover:bg-gray-700'
                : 'bg-white text-[#1B365D] border border-gray-200 hover:border-[#1B365D]/30 hover:shadow-md'
            }`}
          >
            {icon && <span>{icon}</span>}
            {label}
            {to === '/' && <FaArrowRight size={11} />}
          </Link>
        ))}
      </motion.div>

      {/* Ligne déco en bas */}
      <motion.div
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 0.6, delay: 0.6 }}
        className="mt-16 w-24 h-1 bg-yellow-400 rounded-full"
      />
    </div>
  );
}
